import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";

// Default location (company example)
const center = {
  lat: 28.6139,   // replace with your latitude
  lng: 77.2090,   // replace with your longitude
};

function GoogleMapComponent() {
  // Use 100% so parent div controls the size
  const containerStyle = {
    width: "100%",
    height: "100%", 
  };

  return (
    <div className="w-full h-80 rounded-[1.5rem] mb-10 shadow-lg border border-white dark:border-gray-700 relative overflow-hidden">
      <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAP_KEY}>
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={center}
          zoom={15}
        >
          <Marker position={center} />
        </GoogleMap>
      </LoadScript>
    </div>
  );
}

export default GoogleMapComponent;
